import React from "react";
import { connect } from "react-redux";
import { logError } from "redux/actions";
import { v4 as uuidv4 } from "uuid";
import logo from "../images/new-branding-2.0/aivr-hybrid.svg";
import OBCButton from "./OBC/OBCButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

class ErrorBoundaryComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            uuid: "",
        };
    }

    componentDidCatch(error, info) {
        const uuid = uuidv4();

        this.setState({
            uuid: uuid,
            hasError: true,
        });

        const errorMetadata = {
            message: error.message,
            stack: error.stack,
            componentStack: info.componentStack,
            url: window.location.href,
            uuid,
        };

        if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
            this.props.dispatch(logError(errorMetadata));
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div class="ErrorBoundary">
                    <div className="LogoContainer">
                        <img
                            className="ErrorBoundaryLogo"
                            src={logo}
                            alt="AIVR Logo"
                            crossOrigin={"anonymous"}
                        />
                    </div>

                    <div className="MessageContainer">
                        <h1>An unexpected error occured</h1>
                        <p class="ErrorBoundaryText">Apologies for the inconvenience. The error has been automatically reported to our engineering team.</p>

                        <OBCButton
                            className="ErrorRefreshButton"
                            onClick={() => window.location.reload()}>
                            Refresh the page
                        </OBCButton>
                    </div>

                    <div className="ContactContainer">
                        <h2>Contacting us</h2>

                        <div className="UuidContainer">
                            <p>{this.state.uuid}</p>
                            <FontAwesomeIcon
                                onClick={() => {
                                    navigator.clipboard.writeText(this.state.uuid);
                                }}
                                className={"CopyIcon"}
                                icon={faCopy}
                            />
                        </div>

                        <p>
                            If you would like to <a href={`mailto:support@onebigcircle.co.uk?subject=AIVR Platform bug - Ref ${this.state.uuid}`}>contact us</a>
                            , please quote this unique reference number
                        </p>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

const ErrorBoundary = connect()(ErrorBoundaryComponent);
export default ErrorBoundary;
